import React, { useState } from "react";
import Navbar from "../widgets/Navbar";
import PartnerSidebar from "../widgets/PartnerSidebar";
import { useTranslation } from "react-i18next";
import { baseUrl } from "../constant/BaseUrl";
import axios from "axios";

const PartnerResource = () => {
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const downloadBanner = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
        },
        responseType: "blob", // must be set here
      };

      const data = {
        lang: selectedLanguage,
      };

      const response = await axios.post(
        baseUrl + "/download-assets-banner",
        data,
        config
      );
      const blob = response.data;
      const contentDisposition = response.headers["content-disposition"];
      let filename = "download.png"; // fallback
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1].trim(); // 👈 trim extra characters
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div>
       <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container ">
          <div className="row ">
        <PartnerSidebar />
        <div className="col-xl-9 col-lg-8">
        <h5 className="mb-3">{t("Partner Resource")}</h5>
        <div className="p-3 p-md-4 bg2 br10 mb-3">
          <h5 className="mb-2">
            {" "}
            Choose Advertisement Materials For Any Purposes
          </h5>
          <p className="mb-0">
            Explore and access advertisement materials effortlessly. Simply
            check the available options, view the content, and download the
            materials for your intended purpose with ease
          </p>
        </div>
        <div className="p-3 p-md-4 bg2 br10 mb-3 ">
          <div className="d-md-flex pt-2 pb-2 partner-report-box">
            <div className="d-flex mr-auto  align-items-center mb-md-0 mb-3">
              <label>Language</label>
              <select
                className="form-control ml-3"
                onClick={(e) => setSelectedLanguage(e.target.value)}
              >
                <option value={"en"}>English</option>
                <option value={"hi"}>Hindi</option>
              </select>
            </div>
            <div className="d-flex">
              <button className="btn mr-3 ml-auto">
                Social Media Material
              </button>
              <button className="btn btn_border" onClick={downloadBanner}>
                Website Banner
              </button>
            </div>
          </div>
          <hr />
        </div>
        </div>
        </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerResource;
